import http from '../helpers/http';
import ScheduleTimeslotSettingsInterface from '../interfaces/ScheduleTimeslotSettingsInterface';

const ScheduleTimeslotSettings = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    show: async (schoolId: string) => {
      const result = await http.get(`/timeslot-settings/${schoolId}`, {
        headers,
      });
      return result.data;
    },
    createOrUpdate: async (body: Partial<ScheduleTimeslotSettingsInterface>) => {
      const result = await http.post(`/timeslot-settings`, body, { headers });
      return result.data;
    },
  };
};

export default ScheduleTimeslotSettings;
